/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChangeMetricDTO } from './changeMetricDTO';
import { ChangeAnalysisHoverMetricDTO } from './changeAnalysisHoverMetricDTO';


export interface ChangeAnalysisDriverDTO { 
    /**
     * Raw component identifier from the decomposition index
     */
    name: string;
    /**
     * Human-readable driver label for chart display
     */
    label: string;
    /**
     * Driver category: media or non-media
     */
    category: ChangeAnalysisDriverDTO.CategoryEnum;
    /**
     * Bar value in the unit implied by viewBy (orders or percent of comparison total)
     */
    value: number;
    /**
     * Pre-formatted bar value for display
     */
    formattedValue: string;
    /**
     * Direction of the change: UP if value increased, DOWN if it decreased
     */
    arrowDirection: ChangeAnalysisDriverDTO.ArrowDirectionEnum;
    /**
     * Whether this driver\'s change is positive for the business
     */
    isChangePositive: boolean;
    orders: ChangeMetricDTO;
    /**
     * Media input metrics for the bar tooltip; empty for non-media drivers and channels absent from the dataset
     */
    driversOfChange: Array<ChangeAnalysisHoverMetricDTO>;
}
export namespace ChangeAnalysisDriverDTO {
    export type CategoryEnum = 'media' | 'non-media';
    export const CategoryEnum = {
        Media: 'media' as CategoryEnum,
        NonMedia: 'non-media' as CategoryEnum
    };
    export type ArrowDirectionEnum = 'UP' | 'DOWN';
    export const ArrowDirectionEnum = {
        Up: 'UP' as ArrowDirectionEnum,
        Down: 'DOWN' as ArrowDirectionEnum
    };
}


